import { asType, get } from "./Request";

export async function getVersions(token: string): Promise<Record<string, string>> {
  const response = await get(`version`, token);
  return asType(response);
}
